import * as React from "react";
import Component from "../../../../AbstractComponent";
//import { formatDate } from "../utils/formatDate";

export default class BillDetails extends Component {
  public componentWillMount(): void {
    console.log("<BillDetails ");
    console.log(" props=", this.props);
    console.log("/>");
  }

  render() {
    return (
      <div className="coach_newBillSettlement_step_section">
        <div className="coach_newBillSettlement_step_section_header">
          <div className="coach_newBillSettlement_step_section_header_title">
            {this.trans(
              "coach/new-bill-settlement/steps/unit/section-one/title"
            )}
          </div>
        </div>
        <div className="coach_newBillSettlement_step_section_content">
          <div className="coach_newBillSettlement_step_section_content_item">
          <div className="coach_newBillSettlement_step_section_content_item_row">
              <div className="coach_newBillSettlement_step_section_content_item_row_label">
                {this.trans(
                  "coach/new-bill-settlement/steps/unit/section-one/company/label"
                )}
              </div>
              <div className="coach_newBillSettlement_step_section_content_item_row_value">
                {this.props.state?.company?.displayName ?? ""}
              </div>
            </div>
            <div className="coach_newBillSettlement_step_section_content_item_row">
              <div className="coach_newBillSettlement_step_section_content_item_row_label">
                {this.trans(
                  "coach/new-bill-settlement/steps/unit/section-one/table/utility-bill/label"
                )}
              </div>
              <div className="coach_newBillSettlement_step_section_content_item_row_value">
                {this.props.state?.chargeTypeForLandlord?.label ?? ""}
              </div>
            </div>
            <div className="coach_newBillSettlement_step_section_content_item_row">
              <div className="coach_newBillSettlement_step_section_content_item_row_label">
                {this.trans(
                  "coach/new-bill-settlement/steps/unit/section-one/table/bill-period/label"
                )}
              </div>
              <div className="coach_newBillSettlement_step_section_content_item_row_value">
                {`${this.formatter.formatDate(this.props.state?.periodFirst)} - ${this.formatter.formatDate(this.props.state?.periodLast)}`}
              </div>
            </div>
            <div className="coach_newBillSettlement_step_section_content_item_row">
              <div className="coach_newBillSettlement_step_section_content_item_row_label">
                {this.trans(
                  "coach/new-bill-settlement/steps/unit/section-one/table/total-bill-amount/label"
                )}
              </div>
              <div className="coach_newBillSettlement_step_section_content_item_row_value">
                {Number(
                  this.props.state.bill_calculations?.total_amount || 0
                ).toFixed(2)}{" "}
                EUR
              </div>
            </div>
            <div className="coach_newBillSettlement_step_section_content_item_row">
              <div className="coach_newBillSettlement_step_section_content_item_row_label">
                {this.trans(
                  "coach/new-bill-settlement/steps/unit/section-one/table/administration-fee/label"
                )}
              </div>
              <div className="coach_newBillSettlement_step_section_content_item_row_value">
                {Number(
                  this.props.state.bill_calculations
                    ?.administration_percentage_fee || 0
                ).toFixed(2)}{" "}
                %
              </div>
            </div>
            <div className="coach_newBillSettlement_step_section_content_item_row">
            <div className="coach_newBillSettlement_step_section_content_item_row_total">
              <div className="coach_newBillSettlement_step_section_content_item_row_label_total">
                {this.trans(
                  "coach/new-bill-settlement/steps/unit/section-one/table/total-settled-amount/label"
                )}
              </div>
              <div className="coach_newBillSettlement_step_section_content_item_row_value_total">
                {Number(
                  this.props.state.bill_calculations?.total_settled_amount || 0
                ).toFixed(2)}{" "}
                EUR
              </div>
            </div>
            </div>
            {/* <div className="coach_newBillSettlement_step_section_content_item_row">
              <div className="coach_newBillSettlement_step_section_content_item_row_label">
                {this.trans(
                  "coach/new-bill-settlement/steps/unit/section-one/table/monthly/label"
                )}
              </div>
              <div className="coach_newBillSettlement_step_section_content_item_row_value">
                {this.props.state.monthlyPayment} EUR
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}
